import { render, staticRenderFns } from "./Ebs.vue?vue&type=template&id=1ffdfad6&scoped=true"
import script from "./Ebs.vue?vue&type=script&lang=js"
export * from "./Ebs.vue?vue&type=script&lang=js"
import style0 from "./Ebs.vue?vue&type=style&index=0&id=1ffdfad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdfad6",
  null
  
)

export default component.exports